'use client';
import './Link.css';
import { ReactNode } from 'react';
import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom';

interface LinkProps extends Partial<RouterLinkProps> {
	children: ReactNode;
	path: string | null;
	toastRef?: any;
}

const Link = ({ children, path, toastRef, ...rest }: LinkProps) => {
	const onClick = async (e: any) => {
		if (e.ctrlKey || e.metaKey) {
			// do not execute the following logic as the link will be opened in
			// a new tab.
			return;
		}
		if (toastRef?.current) {
			toastRef.current.hide();
		}
		if (path === location.pathname + location.search) {
			e.preventDefault();
			window.location.reload();
			return;
		}
	};

	if (path == null) {
		return children;
	}

	return (
		<RouterLink to={path} onClick={onClick} {...rest}>
			{children}
		</RouterLink>
	);
};

export { Link };
